import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// --- PrimeNG ---
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';

// --- Component ---
import { SearchBoxComponent } from './search-box.component';

@NgModule({
	declarations: [SearchBoxComponent],
	imports: [
		CommonModule,
		FormsModule,

		// --- PrimeNG ---
		ButtonModule,
		InputTextModule,
		TooltipModule,
	],
	exports: [SearchBoxComponent],
})
export class SearchBoxModule {}
